import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Segment, Header, Button, Container, Grid, Message, Icon, Input } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';
import defaultAvatar from 'img/default-avatar.png';

import {colors, spacings, fontSizes, fonts} from 'style';
import styleDef from './style.js';

const style = {
    ...styleDef,
    title: {
        fontSize: fontSizes.h3,
        color: colors.themeBlue,
    },
    typeName: {
        fontSize: fontSizes.h4,
        lineHeight: '1.5',
    },
    userProfile: {
        display: 'inline-block',
        margin: '20px 20px 20px 20px',
        verticalAlign: 'top',
    },
    labelImage: {
        width: '35px',
        height: '35px',
        display: 'inline-block', 
        borderRadius: '50%', 
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundColor:colors.themeBlue,
        margin: '0px 0px 0px 0px',
        opacity: '1',
    },
    userName: {
        opacity: '0.7',
        fontSize: '0.9em',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    descriptionLabel: {
        color: '#000',
        opacity: '0.8',
        fontWeight: 'bold',
    },
    teamLabel: {
        color: colors.themeBlue,
    },
    points: {
        color: colors.pointsYellow,
    },
    bannerWrapper: {
        display: 'block',
        width: '100%',
    },
    description: {
        ...fonts.body,
        lineHeight: '1.5',
        paddingBottom: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '40rem',
    },
    source: {
        color: colors.themeLightBlue,
    },
    reference: {
        textDecoration: 'underline',
        color: colors.themeLightBlue,
    },
};


const getUserName = (userProfile) => {
    if(!userProfile.firstName && !userProfile.lastName) {
        return userProfile.email;
    }
    return Utils.titleCase(userProfile.firstName + ' ' + Utils.limitTo(userProfile.lastName,1))
}


const Confirm = ({t,
                  challenge, 
                  onComplete,
                  buttonText,
                  completePending}) => (
    <Container style={style.container}>
        <div style={style.containerDiv}>
            <Segment style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <Grid.Row verticalAlign='top' style={style.topRow}>
                        <Grid.Column verticalAlign='top'>
                            <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                            <div style={style.title}>{challenge.title}</div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>
                            <div style={style.description}>
                                {Utils.endlToBr(challenge.description)}
                                <br/>
                                {challenge.reference &&
                                    <div style={style.source}>
                                        <Trans i18nKey="source_reference">Source: <a href={Utils.getHref(challenge.referenceUrl)} style={style.reference}>{{reference:challenge.reference}}</a></Trans>
                                    </div>
                                }
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                  
                    <Grid.Row verticalAlign='bottom'>
                        <Grid.Column verticalAlign='bottom' textAlign='center'>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
            <div style={style.button} onClick={onComplete}>{buttonText}</div>
        </div>
    </Container>
);

const ConfirmTC = ({t,
                    challenge, 
                    onComplete,
                    buttonText,
                    completePending,
                    teamChallengeData}) => (
    <Container style={style.container}>
        <div style={style.containerDiv}>
            <Segment style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>

                            <div style={style.teamLabel}>{t('Your Team')}</div>
                            <div>
                                {teamChallengeData.userProfiles.map(userProfile=>(
                                    <div key={userProfile.id} style={style.userProfile}>
                                        <div style={{...style.labelImage, backgroundImage:'url('+((userProfile.avatar!=null) ? userProfile.avatar.url : defaultAvatar)+')'}}></div>
                                        <div style={style.userName}>{getUserName(userProfile)}</div>
                                    </div>
                                ))}
                            </div>
                            
                            <div>
                                <div style={style.teamLabel}>{t('Winning Team Bonus:')}</div>
                                <div style={style.points}><i className='icon-star'/> {teamChallengeData.leaderboard.points}</div>
                            </div>
                            <br />
                            <div>
                                <div style={style.teamLabel}>{t('Activity Points:')}</div>
                                <div style={style.points}><i className='icon-star'/> {challenge.points}</div>
                            </div>
                            <br />

                            <div style={style.descriptionLabel}>{t('Instruction')}</div>
                            {Utils.endlToBr(challenge.description)}
                        </Grid.Column>
                    </Grid.Row>
                  
                    <Grid.Row verticalAlign='bottom'>
                        <Grid.Column verticalAlign='bottom' textAlign='center'>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
            <div style={style.button} onClick={onComplete}>{buttonText}</div>
        </div>
    </Container>
);

const ConfirmTran = translate('challenges')(Confirm);
const ConfirmTCTran = translate('challenges')(ConfirmTC);
export {ConfirmTran as Confirm};
export {ConfirmTCTran as ConfirmTC};



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/Confirm.js